import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { useState } from 'react'
import { MailIcon } from '../components/Icons'

export const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact',
  component: ContactComponent,
})

// Assembled at runtime to keep the address out of static HTML for scrapers.
const emailParts = ['contact', '@', 'cloudymedia', '.', 'com']

function ContactComponent() {
  const [email] = useState(() => emailParts.join(''))

  return (
    <div className="page contact-page">
      <div className="container">
        <header className="page-header">
          <span className="eyebrow">contact</span>
          <h1 className="page-title">Let's talk.</h1>
          <p className="page-subtitle">
            Support, partnerships, press, or just a good hand of Truco. One
            inbox, real humans on the other side.
          </p>
        </header>
      </div>

      <section className="section">
        <div className="container split">
          <div className="contact-card">
            <span className="eyebrow">email</span>
            {email ? (
              <a href={`mailto:${email}`} className="email-link">
                <MailIcon />
                {email}
              </a>
            ) : (
              <span className="email-placeholder">loading…</span>
            )}
            <p className="card-text">
              We read everything and typically reply within a couple of
              business days.
            </p>
          </div>

          <div>
            <ul className="contact-topics">
              <li>
                <span className="bullet">01</span>
                <span>
                  <strong>Player support</strong>
                  Account issues, bugs, or questions about Gran Truco Argentino.
                </span>
              </li>
              <li>
                <span className="bullet">02</span>
                <span>
                  <strong>Partnerships</strong>
                  Publishing, distribution, licensing and co-development.
                </span>
              </li>
              <li>
                <span className="bullet">03</span>
                <span>
                  <strong>Press &amp; media</strong>
                  Interviews, assets and information about the studio.
                </span>
              </li>
            </ul>

            <div className="spec-list" style={{ marginTop: '2rem' }} aria-label="Studio details">
              <div className="spec-row">
                <span className="spec-key">org</span>
                <span className="spec-val">Cloudymedia</span>
              </div>
              <div className="spec-row">
                <span className="spec-key">location</span>
                <span className="spec-val">Buenos Aires, Argentina</span>
              </div>
              <div className="spec-row">
                <span className="spec-key">timezone</span>
                <span className="spec-val">UTC−3 (ART)</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
